import { Loader } from '../loader'
import { colors } from '../../../app-v2/design-systems'
import React from 'react'
import { useIntl } from 'react-intl'
import {
    StyledLoaderWrapper,
    StyledScannerOverlay,
    StyledSight
} from './styles'
import { ErrorDisplay } from './ErrorDisplay'

type Props = {
    color: string,
    loading: boolean,
    helpText?: string,
    error?: string
}
export const ScannerOverlay = (props: Props) => {
    const intl = useIntl()
    return (
        <>
            <ErrorDisplay error={props.error} />
            <StyledScannerOverlay idleColor={props.color}>
                <StyledSight color={props.color} />
                <p>
                    {props.helpText ||
                        intl.formatMessage({
                            id: 'qr.code.scanner.instruction'
                        })}
                </p>
                <StyledLoaderWrapper>
                    <Loader
                        loading={props.loading}
                        color={colors.mayoEggWhite}
                        size={48}
                    />
                </StyledLoaderWrapper>
            </StyledScannerOverlay>
        </>
    )
}
